import React from 'react';
import KeywordPositionList from './KeywordPositionList';
import { useTranslation } from 'react-i18next';

const KeywordPositionSection = ({ keywordData }) => {
  const { t } = useTranslation();

  if (!keywordData) return null;

  return (
    <div className="keyword-position-section">
      <div className="keyword-position-title">
        {t('Position du mot clé avec le top 3 concurrents')}
      </div>

      <hr className="keyword-position-divider" />

      <KeywordPositionList items={keywordData.before} />
    </div>
  );
};

export default KeywordPositionSection;
